import {actionTypes, flightTypes, workplaceTypes} from "../types";
import { HeaderMenuBlock } from '../Block/HeaderMenuBlock/HeaderMenuBlock'

import { isEnabledMsg, isUnreadMsg } from "@/utils.js";
import { VehicleNumberBlock } from "../Block/VehicleNumberBlock";
import { TIME_FORMAT } from '@/utils.js';
import { appNotification } from '@/components/AppNotification.js'
import { storage } from "@/components/Storage";
import { user } from "@/components/User";
import { cache } from '@/components/Cache.js';
import { interval } from '@/components/Interval.js';
import { loader } from '@/components/Loader.js';
import { server } from '@/components/Server.js';

export const VehicleTask = {
    state: {
        time: null,
        tasks: [],
        error: '',
        data: null,
        standsDistance:[],
        topMenu: [
            { title: 'Задачи', url: '/vehicle/tasks', icon: 'fa-tasks' },
            { title: 'Техника', url: '/vehicle', icon: 'fa-truck' },
            { title: 'Профиль', url: '/profile', icon: 'fa-user' },
            isEnabledMsg() ? { title: 'Сообщения', url: '/message', icon: isUnreadMsg() ? 'fa-envelope-o' : 'fa-envelope-open-o' } : {},
            { title: 'Выйти', url: '/logout', icon: 'fa-sign-out' }
        ]
    },

    init: function (ping) {
        if (user.get('state.vehicleFreeTasksAvailable') && !this.state.topMenu.filter((item) => {return item.title === 'Свободные'})
        ) {
            this.state.topMenu.unshift(
                { title: 'Свободные', url: '/vehicle/tasks/free', icon: 'fa-car' }
            )
        }
        
        return m.request({
            method: 'GET',
            url: '/api/vehicle/tasks',
            extract(xhr) {
                VehicleTask.state.data = xhr;
                if ([401, 403].includes(xhr.status)) {
                    localStorage.clear();
                    document.location.href = "/login";
                }

                return xhr.response;
            }
        }).then(function (response) {
            server.setOnline();

            VehicleTask.state.data = response;
            VehicleTask.state.time = response.time;
            VehicleTask.state.tasks = response.tasks;
            VehicleTask.state.standsDistance = response.standsDistance;

            appNotification.list = response.notifications;

            loader.hide();
            storage.config = response.config;

            if (ping) {
                server.initPing();
                appNotification.init();
            }

            return response;
        }, function (response) {
            if (response && response.message) {
                VehicleTask.state.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    },
    initIntervalRefresh: function () {
        interval.make(function () {
            VehicleTask.init(false)
        }, 30000)
    },
    update: function (key, value) {
        VehicleTask.state.tasks[key] = value;
    },
    confirmTask: function (key) {
        VehicleTask.state.error = '';
        loader.show();

        const task = VehicleTask.state.tasks[key];

        m.request({
            method: 'PUT',
            url: '/api/task/' + task.id + '/confirm'
        }).then(function () {
            loader.hide();

            task.isConfirmed = true;
            task.url = '/task/' + task.id + '/works';
            VehicleTask.update(key, task);

        }, function (response) {

            cache.push({
                type: actionTypes.taskConfirm,
                taskId: task.id,
                ts: moment().format(TIME_FORMAT)
            });

            if (response && response.message) {
                VehicleTask.state.error = (m(".alert.alert-danger", response.message));
            } else {
                server.setOffline();
            }
            loader.hide();
        });
    }
};

export const VehicleTasksPage = {
    controller: function () {
        if (!user.exists()) {
            m.route('/login');
            return;
        }
        if (!user.has('state.workplace')) {
            m.route('/workplace');
            return;
        }
        if (user.get('state.workplace') !== workplaceTypes.driver) {
            m.route('/');
            return;
        }

        interval.clearAll();

        loader.show();

        VehicleTask.init(true); // заполняет VehicleTask.state

        setTimeout(function () {
            VehicleTask.initIntervalRefresh()
        }, 500);


        return {};
    },

    
    displayReadiness: function (task) {
        const readiness = VehicleTask.state.data?.readiness?.[task.id]
        if (!readiness)
            return;

        const time = moment(readiness.updated_at, 'YYYY-MM-DD HH:mm:ss').format('HH:mm')
        return parseInt(readiness.status)
            ? m("div.text-white[style='font-size:0.8em;line-height:1;background:green;']", `готовность ${time}`)
            : m("div.text-white[style='font-size:0.8em;line-height:1;background:red;']", `отмена готовности ${time}`)
    },

    displayStandsDistance: function (task) {
        const standsDistanceArr = VehicleTask.state.standsDistance
        if (!standsDistanceArr) return;

        let standsDistanceForTask = standsDistanceArr.filter(data => {
            return data.work_id == task.id
        });
        if (!standsDistanceForTask.length) return;
            
        standsDistanceForTask = standsDistanceForTask[0];
        if (!standsDistanceForTask.stand_from_id && !standsDistanceForTask.stand_to_id) return;

        return [
            m("div[style='font-weight:normal;font-size:0.75em;']",'Стоянка от ' + standsDistanceForTask.stand_from_name),
            m("div[style='font-weight:normal;font-size:0.75em;']",'Стоянка до ' + standsDistanceForTask.stand_to_name),
        ];

    },
/** название ТС и кнопки для технологических работ **/
    view: function (ctrl) {
        return [
            m.component(HeaderMenuBlock, {
                time: VehicleTask.state.time,
                menu: VehicleTask.state.topMenu
            }),
            m("div[style='margin-top:0px']", VehicleTask.state.error),
            VehicleNumberBlock(VehicleTask.state.data),
            m("table.table.table-bordered.table-condensed", [
                m("thead", [
                    m("tr", [
                        m("th.text-center", "Работа"),
                        m("th.text-center", "Время"),
                        m("th.text-center", "МС\nВС"),
                        m("th", "")
                    ])
                ]),
                m("tbody", [
                    VehicleTask.state.tasks.map(function (task, i) {
                        return m("tr", {class: task.isOverdue ? 'bg-grey' : ''}, [
                            m("td", [
                                m("a.btn.btn-block.btn-lg", {
                                        href: task.url,
                                        class: task.hasAlerts ? 'btn-warning progress-bar-striped' : 'btn-default',
                                        config: m.route
                                    },
                                    task.isCrossWork ? m("i.fa.fa-2x.fa-exclamation") : '',
                                    m("div.d-flex.flex-column", [
                                        m('', [
                                        m('', task.flightNumber),
                                        task.flightType === flightTypes.departure ?
                                            [m('img', {src: "/img/departure.png"}), m.trust('&nbsp;' + task.airportCode)] : '',
                                        task.flightType === flightTypes.arrival ?
                                            [m('img', {src: "/img/arrival.png"}), m.trust(task.airportCode + '&nbsp;')] : '',
                                        task.flightType === flightTypes.around ?
                                            [m('img', {src: "/img/around.png"}), m.trust('&nbsp;' + task.airportCode)] : '',
                                        ]),
                                        m('', task.Work_Name),
                                        VehicleTasksPage.displayReadiness(task),
                                        VehicleTasksPage.displayStandsDistance(task),
                                    ])
                                )
                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.flightTime),
                                m("br"),
                                m("span", task.flightDate),
                                task.expectedTime ? [
                                    m("br"),
                                    task.flightType === flightTypes.departure ?
                                        [   m("span.small-text[style='color:#008334; font-size:15px']", "EOBT"),
                                            m("br"),
                                            m("span.small-text[style='color:#008334; font-size:20px']", task.expectedTime) ] : '',
                                    task.flightType === flightTypes.arrival ?
                                        [   m("span.small-text[style='color:#008334; font-size:15px']", "VPEM"),
                                            m("br"),
                                            m("span.small-text[style='color:#008334; font-size:20px']", task.expectedTime) ] : '',
                                    ] : [],
                                task.EntranceZoneTime ? [
                                    m("br"),
                                    m("span.small-text[style='color:red; font-size:15px']", "Вход АП"),
                                    m("br"),
                                    m("span.small-text[style='color:red; font-size:20px']", task.EntranceZoneTime) ] : [],

                            ]),
                            m("td.text-center.v-center", [
                                m("span.big-text", task.parkingNumber),
                                m("br"),
                                m("span", task.typeVS),
                                m("br"),
                                m("span", task.boardNumber)
                            ]),
                            m("td.col-xs-2.text-center.v-center", [
                                task.isConfirmed ?
                                    m("i.fa.fa-3x.fa-check.text-primary") :
                                    m("button.btn.btn-info", {
                                        onclick: function () {
                                            VehicleTask.confirmTask(i);
                                        }
                                    }, [
                                        m("i.fa.fa-2x.fa-thumbs-o-up")
                                    ])
                            ])
                        ])
                    })
                ])
            ])
        ];
    }
};
